import { AnalyticsEvents } from './Analytics';
import { AppStateProvider, useGlobalState } from './AppStateContext';

type PageInitParams = {
  documentId: string;
  revision: string;
  journalCode: string;
  journal: string;
  resultsPerPage: number;
  title: string;
};

const PageInit = (initDetails: PageInitParams, state: any) => ({
  type: AnalyticsEvents.InitPageLoad,
  payload: {
    ...state,
    ...initDetails,
  }
})

const PageRendered = (pagename: string, state:any) => ({
  type: AnalyticsEvents.PageRendered,
  payload: {
    ...state,
    pagename: pagename,
  }
})

const LinkClick = (linkDetails: { refType: string, refTitle: string, itemId: string, itemLocation: string }, state:any) => ({
  type: AnalyticsEvents.LinkClick,
  payload: { ...state, ...linkDetails }
})

const FacetsUpdated = (facets: any, state:any) => ({
  type: AnalyticsEvents.FiltersUpdated,
  payload: { ...state, filters: facets }
})


export { AppStateProvider, useGlobalState }
export { PageInit, PageRendered, LinkClick, FacetsUpdated }
